// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__10-VX","row":"ProcedureTreatmentSummary_row__UHl1Z"};